
import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/DepartmentApi/Department";
import { validateForm } from "utils/validation";
import { DepartmentRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddDepartmentForm from "./components/AddDepartmentForm";
import fields from "../json/Department.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddDepartment = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        DepartmentRules
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, DepartmentRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Department created successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddDepartmentForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default AddDepartment;
